<template>
	<div class="layout-footer flex align-items-center p-4 flex-column sm:flex-row">
    <img id="footer-logo" :src="appState.user.preferences.appLayoutMode === 'light' ? whqLogoColorBlack : whqLogoColorWhite" alt="WarehouseQuote Footer Logo" />
    <p class="text-center sm:text-right mt-3 mb-0 sm:mt-0 sm:ml-auto lg:mr-7">
      Copyright &copy; {{new Date().getFullYear()}} WarehouseQuote.com
      <small class="block">
        <a href="https://www.warehousequote.com/accessibility-statement/" target="_blank">Accessibility</a>
        <span class="mx-2">|</span>
        <AppKeyboardShortcuts />
        <span class="mx-2">|</span>
        <span class="inline-block">Version {{versionNumber.major}}.{{versionNumber.minor}}.{{versionNumber.patch}}</span>
      </small>
    </p>
  </div>
</template>

<script setup>
  import { inject } from "vue";
  import AppKeyboardShortcuts from "@/views/_app/AppKeyboardShortcuts.vue";
  import versionNumber from "@/data/versionNumber.json";
  import whqLogoColorBlack from "@/images/whq-logo-color-black-horizontal.png";
  import whqLogoColorWhite from "@/images/whq-logo-color-white-horizontal.png";
  const appState = inject("appState");
</script>